<template>
  <b-container fluid>
    <backlink/>
    <h1>Familles d'entreprise</h1>

    <AdminTable :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "CompanyGroupList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CompanyGroup/CompanyGroupList.vue